<template>
<div class="page-proreport">
	<div class="head">
		<div class="avatar">
			<img v-bind:src="selfResult.avatar">
		</div>
		<h1>你的动物画像专业报告</h1>
	</div>
	<div class="body">
		<div class="desc">
			<div  v-html="funreport.basic_discription"></div>
		</div>
		<div v-bind:class="[ funreport.key, 'position']">
			<div class="top t">外向</div>
			<div class="left t">关系主导</div>
			<div class="right t">工作主导</div>
			<div class="bottom t">内向</div>
			<img class="avatar" v-bind:style="funreport.coordinate" v-bind:src="selfResult.avatar">
		</div>
		<div class="inPeopleEye">
			<div v-bind:class="[ 'onp', 'lovers',  Onp.lovers?'open':'' ]" @click="toggleOnp('lovers')">
				<div class="whom"></div>
				<div class="desc" v-html="funreport.in_lover"></div>
				<div class="arrow"></div>
			</div>
			<div v-bind:class="[ 'onp', 'friends',  Onp.friends?'open':'' ]" @click="toggleOnp('friends')">
				<div class="whom"></div>
				<div class="desc" v-html="funreport.in_friends"></div>
				<div class="arrow"></div>
			</div>
			<div v-bind:class="[ 'onp', 'colleague',  Onp.colleague?'open':'' ]" @click="toggleOnp('colleague')">
				<div class="whom"></div>
				<div class="desc" v-html="funreport.in_colleagues"></div>
				<div class="arrow"></div>
			</div>
			<div v-bind:class="[ 'onp', 'parents',  Onp.parents?'open':'' ]" @click="toggleOnp('parents')">
				<div class="whom"></div>
				<div class="desc" v-html="funreport.will_be"></div>
				<div class="arrow"></div>
			</div>
		</div>

		<div class="yqd">
			<ul class="tabs">
				<li v-bind:class="[ 'tab', 'youdian', Tab=='youdian'? 'show':'']"
						@click="switchTab('youdian')"></li>
				<li v-bind:class="[ 'tab', 'quedian', Tab=='quedian'? 'show': '']"
						@click="switchTab('quedian')"></li>
				<li v-bind:class="[ 'tab', 'jianyi', Tab=='jianyi'? 'show': '']"
						@click="switchTab('jianyi')"></li>
			</ul>
			<ul class="tab_conts">
				<li v-bind:class="[ 'tab_cont', 'youdian', Tab=='youdian'? 'show':'']" v-html="funreport.advantage"></li>
				<li v-bind:class="[ 'tab_cont', 'quedian', Tab=='quedian'? 'show': '']" v-html="funreport.shortcoming"></li>
				<li v-bind:class="[ 'tab_cont', 'jianyi', Tab=='jianyi'? 'show': '']" v-html="funreport.suggest"></li>
			</ul>
		</div>

		<div class="jobs">
			<div class="title"></div>
			<div class="desc">{{funreport.match_jobs}}</div>
		</div>

		<div class="qrcode">
			<img src="../../static/images/funreport-qrcode.png" alt="qrcode">
		</div>
		<div class="toFunreport">
			<a href="javascript:;" class="btn" @click="toFunreport()">趣味报告点这里</a>
		</div>

		<yxl-logo></yxl-logo>
	</div>
</div>
</template>

<script>
import data from '../data.js'
import { mapState } from 'vuex'
import { mapActions } from 'vuex'
import { mapMutations } from 'vuex'
import axios from 'axios'
import store from '../store.js'
import APIS from '../apis.js'
import router from '../router.js'


import yxlLogo from '../components/yxl-logo.vue'

export default {
	name: 'proreport',
	components: {
		yxlLogo: yxlLogo
	},
	beforeRouteEnter (to, from, next){
		axios.get(APIS.getSelfReport, {
			params: {
				'isWeiXin': to.query.isWeiXin?to.query.isWeiXin:0,
			}
		}).then(function(res) {
			var res = res.data;
			if(res.code==200) {
				store.commit('setFunreport', {report:res.data,gender:res.data.gender});
			} else if (res.code == 1001){
          //拿授权
			    window.location.href = APIS.shouquan + '?callback=' + encodeURIComponent(location.href);
      }
		}).then(function() {
			next(vm => {});
		}).catch(function(error){
			console.log(error);
		})
	},
	created() {
		if(this.$route.query.channel_id) {
      this.setChannelId(this.$route.query.channel_id)
    }
    if(this.GetQueryString("channel_id")) {
      this.setChannelId(this.GetQueryString("channel_id"));
    }
	},
	mounted() {
		if( this.selfResult!=undefined & this.selfResult.unlock != '1') {
			router.push({
				name: 'index',
				path: '/index',
				query: {
          channel_id: this.channel_id
				},
			})
		}
		// JS 修改 IOS微信的title
		let body = document.querySelector('body');
		document.title ='专业测评报告';

		this.setStayFun(true);
    document.querySelector('.page-proreport').style.minHeight = window.screen.availHeight + 'px';
		wx.ready(function() {
			wx.hideMenuItems({
			    menuList: [
			    'menuItem:share:qq',
			    'menuItem:share:timeline',
			    "menuItem:share:appMessage",
			    'menuItem:share:weiboApp',
			    'menuItem:share:QZone',
			    "menuItem:openWithSafari",
			    "menuItem:copyUrl"
			    ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
			});
		});
	},
	data() {
		return {
      Onp: {
      	lovers: 0,
      	friends: 0,
      	colleague: 0,
      	parents: 0
      },
      Tab: 'youdian',
    }
	},
	computed: mapState({
			funreport: state => state.funreport,
			selfResult: state => state.selfResult,
			channel_id: state => state.channel_id
	}),
	methods: {
		...mapActions([
			'getSelfReport'
		]),
		...mapMutations([
			'setStayFun',
			'setChannelId'
		]),
		toggleOnp(whom) {
			this.$data.Onp[whom] = !this.$data.Onp[whom];
		},
		switchTab(tabName) {
			this.$data.Tab = tabName;
		},
		toFunreport() {
			this.setStayFun(true);
			router.push({
				path: '/funreport/:stay',
				name: 'funreport',
				query: {
					isWeiXin: this.$route.query.isWeiXin?this.$route.query.isWeiXin:0,
          channel_id: this.channel_id
				}
			})
		}
	}
}
</script>

<style scoped lang="scss">
$font-size-base:32; // Base on 320rem * 0.5;
@function topx($rem) {
  @return $rem/$font-size-base;
}
.page-proreport {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	padding-bottom: topx(70rem * 0.5);
	background: url('../../static/images/all_bg.png');

	.head {
		margin: topx(25rem * 0.5) topx(52rem * 0.5) 0 topx(52rem * 0.5);
		text-align: center;
		font-size: 0;
		border-bottom: topx(1rem * 0.5) solid #d7a323;
		.avatar {
			display: inline-block;
			width: topx(77rem * 0.5);
			height: topx(77rem * 0.5);
			padding: topx(5rem * 0.5);
			border: topx(1rem * 0.5) solid #d6a11e;
			border-radius: topx(87rem * 0.5);
			overflow: hidden;
			img {
				width: topx(77rem * 0.5);
				height: topx(77rem * 0.5);
				border-radius: topx(77rem * 0.5);
			}
		}
		h1 {
			margin: topx(15rem * 0.5) 0 topx(40rem * 0.5) 0;
			font-size: topx(28rem * 0.5);
			color: #3c3c3c;
		}
	}

	.body {
		.desc {
			margin: topx(25rem * 0.5) topx(65rem * 0.5) ;
			color: #252323;
			font-size: topx(22rem * 0.5);
			line-height: topx(36rem * 0.5);
		}
		.position {
			position: relative;
			margin: topx(90rem * 0.5) auto;
			width: topx(320rem * 0.5);
			height: topx(320rem * 0.5);
			background: url('../../static/images/pro_position.png');
			background-size: cover;
			color: #041c38;
			font-size: topx(24rem * 0.5);
			&>div {
				position: absolute;
				line-height: topx(36rem * 0.5);
				font-weight: bold;
			}
			.top {
				top: topx(-40rem * 0.5);
				left: 50%;
		    transform: translate(-50%,0);
			}
			.left {
				width: 1em;
				top: 50%;
				left: topx(-36rem * 0.5);
		    transform: translate(0, -50%);
			}
			.right {
				width: 1em;
				top: 50%;
				right: topx(-36rem * 0.5);
		    transform: translate(0, -50%);
			}
			.bottom {

				bottom: topx(-40rem * 0.5);
				left: 50%;
		    transform: translate(-50%,0);
			}
			.avatar {
				position: absolute;
				width: topx(50rem * 0.5);
				height: topx(50rem * 0.5);
				border-radius: topx(50rem * 0.5);
			}
			&.C {
				.avatar {
					top: 13%;
					right: 13%;
				}
			}
			&.Cm {
				.avatar {
					top: 35%;
					right: 8%;
				}
			}
			&.Cp {
				.avatar {
					top: 37%;
					right: 17%;
				}
			}
			&.Cs {
				.avatar {
					top: 15%;
					right: 27%;
				}
			}
			&.M {
				.avatar {
					right: 13%;
					bottom: 5%;
				}
			}
			&.Mc {
				.avatar {
					right: 13%;
					bottom: 28%;
				}
			}
			&.Mp {
				.avatar {
					right: 30.5%;
					bottom: 6.5%;
				}
			}
			&.Ms {
				.avatar {
					right: 30.5%;
					bottom: 13.5%;
				}
			}
			&.P {
				.avatar {
					left: 18.5%;
					bottom: 3.5%;
				}
			}
			&.Pc {
				.avatar {
					left: 28.5%;
					bottom: 28.5%;
				}
			}
			&.Pm {
				.avatar {
					left: 38%;
					bottom: 2%;
				}
			}
			&.Ps {
				.avatar {
					left: 3%;
					bottom: 37%;
				}
			}
			&.S {
				.avatar {
					left: 10%;
					top: 10%;
				}
			}
			&.Sc {
				.avatar {
					left: 38%;
					top: 4%;
				}
			}
			&.Sm {
				.avatar {
					left: 38%;
					top: 36%;
				}
			}
			&.Sp {
				.avatar {
					left: 8%;
					top: 37%;
				}
			}
			&.cm {
				.avatar {
					right: 10%;
					top: 39%;
				}
			}
			&.cp {
				.avatar {
					right: 20%;
					top: 30%;
				}
			}
			&.cs {
				.avatar {
					right: 37%;
					top: 8%;
				}
			}
			&.mc {
				.avatar {
					right: 8%;
					bottom: 38%;
				}
			}
			&.mp {
				.avatar {
					right: 38%;
					bottom: 8%;
				}
			}
			&.ms {
				.avatar {
					right: 36%;
					bottom: 17%;
				}
			}
			&.pc {
				.avatar {
					left: 38%;
					bottom: 22%;
				}
			}
			&.pm {
				.avatar {
					left: 42%;
					bottom: 12%;
				}
			}
			&.ps {
				.avatar {
					left: 10%;
					bottom: 38%;
				}
			}
			&.sc {
				.avatar {
					left: 35%;
					top: 16%;
				}
			}
			&.scpm {
				.avatar {
					left: 42.3%;
					top: 42.3%;
				}
			}
			&.sm {
				.avatar {
					left: 42.3%;
					top: 38%;
				}
			}
			&.sp {
				.avatar {
					left: 38%;
					top: 13%;
				}
			}
		}
		.inPeopleEye {
			.onp {
				position: relative;
				height: topx(130rem * 0.5);
				margin: 0 topx(48.5rem * 0.5) topx(20rem * 0.5) topx(48.5rem * 0.5);
				padding: 0 topx(25rem * 0.5);
				overflow: hidden;
				border-radius: topx(65rem * 0.5);
				background: #f6f6f6;
				&.open {
					height: auto;
					padding: topx(15rem * 0.5) topx(25rem * 0.5) topx(50rem * 0.5) topx(25rem * 0.5);
					line-height: topx(20rem);
					.desc {
						overflow: auto;
						display: inline;
						line-height: topx(20rem);
					}
					.arrow {
						margin: 0 0 0 topx(-11rem * 0.5) ;
						background: url('../../static/images/pro-arrow-top.png');
						background-size: cover;
					}
				}
				&.lovers {
					.whom {
						margin: topx(130rem - 92) * 0.25 topx(10rem * 0.5) 0 0;
						width: topx(93rem * 0.5);
						height: topx(92rem * 0.5);
						background: url('../../static/images/proreport-lover.png');
						background-size: cover;
					}
				}
				&.friends {
					.whom {
						margin: topx(130rem - 95) * 0.25 topx(10rem * 0.5) 0 0;
						width: topx(94rem * 0.5);
						height: topx(95rem * 0.5);
						background: url('../../static/images/proreport-friends.png');
						background-size: cover;
					}
				}
				&.colleague {
					.whom {
						margin: topx(130rem - 95)*0.25 topx(10rem * 0.5) 0 0;
						width: topx(92rem * 0.5);
						height: topx(95rem * 0.5);
						background: url('../../static/images/proreport-coworker.png');
						background-size: cover;
					}
				}
				&.parents {
					.whom {
						margin: topx(130rem - 102) * 0.25 topx(10rem * 0.5) 0 0;
						width: topx(95rem * 0.5);
						height: topx(102rem * 0.5);
						background: url('../../static/images/proreport-parent.png');
						background-size: cover;
					}
				}
				.whom {
					float: left;
				}
				.desc {
					margin: topx(15rem * 0.5) topx(40rem * 0.5) 0 topx(15rem * 0.5);
					color: #252323;
					font-size: topx(22rem * 0.5);
			    display: -webkit-box;
			    display: -moz-box;
			    overflow: hidden;
			    white-space: normal;
			    text-overflow: ellipsis;
			    word-break: break-all;
			    -webkit-box-orient: vertical;
			    -webkit-line-clamp: 2;
				}
				.arrow {
					position: absolute;
					bottom: topx(10rem * 0.5);
					left: 50%;
					margin-left: topx(48rem * 0.5);
					width: topx(22rem * 0.5);
					height: topx(22rem * 0.5);
					background: url('../../static/images/pro-arrow-bottom.png');
					background-size: topx(22rem * 0.5);
				}
			}
		}
	}

	.yqd {
		margin-top: topx(56rem * 0.5);
		.tabs {
			width: topx(540rem * 0.5);
			margin: 0 topx(50rem * 0.5);
			&:after {
				content: '';
				display: block;
				width: 0;
				height: 0;
				clear: both;
			}
			li {
				position: relative;
				float: left;
				width: 33.33%;
				height: topx(165rem * 0.5);
				&.show:before {
					position: absolute;
					z-index: 9;
					content: '';
					display: block;
					width: 0;
					height: 0;
					bottom: topx(-40rem * 0.5);
					left: 50%;
					margin-left: topx(-18rem * 0.5);
					border: topx(15rem * 0.5) solid transparent;
					border-width: topx(30rem * 0.5) topx(18rem * 0.5) topx(30rem * 0.5) topx(18rem * 0.5);
					border-bottom: topx(30rem * 0.5) solid #fff;
				}
			}
			.youdian {
				background: url('../../static/images/proreport-youdian_off.png') no-repeat center;
				background-size: topx(125rem * 0.5);
				&.show {
					background: url('../../static/images/proreport-youdian.png') no-repeat center;
					background-size: topx(125rem * 0.5);
				}
			}
			.quedian {
				background: url('../../static/images/proreport-quedian_off.png') no-repeat center;
				background-size: topx(125rem * 0.5);
				&.show {
					background: url('../../static/images/proreport-quedian.png') no-repeat center;
					background-size: topx(125rem * 0.5);
				}
			}
			.jianyi {
				background: url('../../static/images/proreport-suggest_off.png') no-repeat center;
				background-size: topx(125rem * 0.5);
				&.show {
					background: url('../../static/images/proreport-suggest.png') no-repeat center;
					background-size: topx(125rem * 0.5);
				}
			}
		}
		.tab_conts {
			width: topx(540rem * 0.5);
			margin: topx(40rem * 0.5) topx(50rem * 0.5) 0 topx(50rem * 0.5);
			li {
				display: none;
				background: #fff;
				border-radius: topx(25rem * 0.5);
				padding: topx(25rem * 0.5) topx(35rem * 0.5);
				color: #252323;
				font-size: topx(22rem * 0.5);
				line-height: topx(40rem * 0.5);
				&.show {
					display: block;
				}
			}
			.youdian {}
			.quedian {}
			.jianyi {}
		}
	}

	.jobs {
		margin-top: topx(60rem * 0.5);
		.title {
			width: topx(197rem * 0.5);
			height: topx(103rem * 0.5);
			margin: 0 auto;
			background: url('../../static/images/proreport-jobs.png') no-repeat;
			background-size: cover;
		}
		.desc {
			margin-top: topx(25rem * 0.5);
			text-align: center;
			font-size: topx(22rem * 0.5);
			color: #252323;
		}
	}

	.qrcode {
		margin: 0 auto;
		width: topx(123rem * 0.5);
		height: topx(123rem * 0.5);
		img {
			width: 100%;
		}
	}

	.toFunreport {
		margin-top: topx(24rem * 0.5);
		margin-bottom: topx(64rem * 0.5);
		text-align: center;
		.btn {
			display: inline-block;
			height: topx(65rem * 0.5);
			padding: 0 topx(23rem * 0.5);
			line-height: topx(67rem * 0.5);
			background: #edc96f;
			border: topx(3rem * 0.5) solid #e6ae24;
			border-radius: topx(10rem * 0.5);
			font-size: topx(26rem * 0.5);
			color: #81600e;
		}
	}
}
</style>



// WEBPACK FOOTER //
// proreport.vue?2dc7e56c